import React from 'react';
import { history } from 'umi';

import styles from '../styles.scss';
import CategoryTitle from './CategoryTitle';


export default (props) => {
  const {dataList,title,onMore} = props;

  return(
    <div>
      <CategoryTitle title={title} onMore={()=> {
        onMore && onMore();
      }}/>

      <div className={styles.horizontal_box}>
        {dataList.map((item,i) =>(

          <div key={''+i} className={styles.horizontal_item} onClick={()=>{
            history.push('/program/programDetail?programId=' + item.columnId + '&videoId=' + item.id + '&title=' + item.column.name);
          }}>
            <div className={styles.horizontal_imgBox}>
              <img src={item.image}/>
              <label className={styles.horizontal_sub}>{item.dateName}</label>
            </div>
            <label className={styles.horizontal_title}>{item.videoName}</label>

          </div>

        ))}

      </div>
    </div>
  )

}
